export default {
  agent: 'Рієлтор',
  owner: 'Власник',
};
